(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dually-project-films"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dually-project-film')) {
    class DuallyProjectFilm extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.posterController?.abort();
        this.controller = new AbortController();
        this.frame = this.querySelector('[data-dually-film-frame]');
        const poster = this.querySelector('[data-dually-film-trigger]');
        if (!this.frame || !poster) return;
        this.poster = poster.cloneNode(true);
        this.initializePoster();
        this.addEventListener('click', (event) => {
          const trigger = event.target instanceof Element ? event.target.closest('[data-dually-film-trigger]') : null;
          if (!trigger || !this.contains(trigger) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const videoId = this.dataset.videoId;
          if (!/^[A-Za-z0-9_-]{11}$/.test(videoId || '')) return;
          event.preventDefault();
          this.closest('.dually-project--films')?.querySelectorAll('dually-project-film').forEach((player) => {
            if (player !== this) player.reset();
          });
          const iframe = document.createElement('iframe');
          iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&playsinline=1&rel=0`;
          iframe.title = this.dataset.videoTitle || trigger.getAttribute('aria-label') || '';
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          iframe.width = '360';
          iframe.height = '640';
          iframe.tabIndex = 0;
          this.posterController?.abort();
          this.frame.replaceChildren(iframe);
          requestAnimationFrame(() => iframe.focus({ preventScroll: true }));
        }, { signal: this.controller.signal });
        const archive = this.closest('details');
        if (archive) {
          archive.addEventListener('toggle', () => {
            if (!archive.open) this.reset();
          }, { signal: this.controller.signal });
        }
      }
      initializePoster() {
        this.posterController?.abort();
        const thumbnail = this.frame?.querySelector('[data-dually-film-trigger] img');
        if (!thumbnail) return;
        this.posterController = new AbortController();
        thumbnail.removeAttribute('data-image-ready');
        const update = () => {
          thumbnail.toggleAttribute('data-image-ready', thumbnail.complete && thumbnail.naturalWidth > 0);
        };
        thumbnail.addEventListener('load', update, { signal: this.posterController.signal });
        thumbnail.addEventListener('error', () => thumbnail.removeAttribute('data-image-ready'), { signal: this.posterController.signal });
        update();
      }
      reset() {
        if (this.poster && this.frame?.querySelector('iframe')) {
          this.frame.replaceChildren(this.poster.cloneNode(true));
          this.initializePoster();
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.posterController?.abort();
      }
    }
    customElements.define('dually-project-film', DuallyProjectFilm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dually-project-partners"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dually-partner-logo')) {
    customElements.define('dually-partner-logo', class extends HTMLElement {
      connectedCallback() {
        this.logo = this.querySelector('.dp-partner__logo');
        this.fallback = this.querySelector('.dp-partner__fallback');
        if (!this.logo || !this.fallback) return;

        this.handleError = () => {
          this.logo.hidden = true;
          this.fallback.hidden = false;
        };
        this.handleLoad = () => {
          this.logo.hidden = false;
          this.fallback.hidden = true;
        };
        this.logo.addEventListener('error', this.handleError);
        this.logo.addEventListener('load', this.handleLoad);

        if (this.logo.complete && this.logo.naturalWidth === 0) this.handleError();
      }

      disconnectedCallback() {
        if (!this.logo) return;
        this.logo.removeEventListener('error', this.handleError);
        this.logo.removeEventListener('load', this.handleLoad);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
